import { get, post } from "../GenericServices";

const KickOff = {
  KickOffSummmaryDetail: (id, year) => {
    return get(`project-estimate/${id}/kick-off/summary/${year}/detail`);
  },
  KickOffSummmaryWipDetail: (id, year) => {
    return get(`project-estimate/${id}/kick-off/summary-wip/${year}/detail`);
  },
  KickOffWpDetail: (id, WpId, year) => {
    return get(`project-estimate/${id}/kick-off/work-package/${WpId}/${year}/detail`);
  },
  KickOffDownloadWP: (projectId, WpId, year) => {
    return get(`project-estimate/${projectId}/kick-off/work-package/${WpId}/${year}/report`);
  },
  KickOffDownloadSummary: (projectId, year) => {
    return get(`project-estimate/${projectId}/kick-off/summary/${year}/report`);
  },
  KickOffTableSummary: (id, year) => {
    return get(`project-estimate/${id}/kick-off/summary/${year}`);
  },
  KickOffTableTotalSummary: (id, year) => {
    return get(`project-estimate/${id}/kick-off/summary/${year}/total`);
  },
  KickOffTableSummaryWip: (id, year) => {
    return get(`project-estimate/${id}/kick-off/summary-wip/${year}`);
  },
  KickOffTableTotalSummaryWip: (id, year) => {
    return get(`project-estimate/${id}/kick-off/summary-wip/${year}/total`);
  },
  KickOffWorkPackage: (id, queryString) => {
    return get(`project-estimate/${id}/work-package?${queryString}`);
  },
  KickOffWorkPackageDetail: (id, wpId, year) => {
    return get(`project-estimate/${id}/kick-off/work-package/${wpId}/${year}/detail`);
  },
  KickOffWorkPackageTable: (id, wpId, year) => {
    return get(`project-estimate/${id}/kick-off/work-package/${wpId}/${year}`);
  },
  KickOffWorkPackageTableTotal: (id, wpId, year) => {
    return get(`project-estimate/${id}/kick-off/work-package/${wpId}/${year}/total`);
  },
  KickOffWorkPackageTableBillingPlan: (id, wpId, year) => {
    return get(`project-estimate/${id}/kick-off/work-package/${wpId}/${year}/billing-plan`);
  },
  KickOffWorkPackageCopy: (id, wpId, year) => {
    return post(`project-estimate/${id}/kick-off/work-package/${wpId}/${year}/copy-cost-estimation`);
  },
  saveKickOffWp: (projectEstimateId, wpId, year, body) => {
    return post(`project-estimate/${projectEstimateId}/kick-off/work-package/${wpId}/${year}`, body);
  },
  projectEstimateKickOffTableWPWbs: (projectId, WpId, wbsId, year) => {
    return get(`project-estimate/${projectId}/kick-off/work-package/${WpId}/${year}/wbs/${wbsId}`);
  },
  resetProjectEstimateKickOffTableWP: (projectId, WpId, year) => {
    return post(`project-estimate/${projectId}/kick-off/work-package/${WpId}/${year}/reset`);
  },
  confirmProjectEstimateKickOffTableWP: (projectId, WpId, year) => {
    return post(`project-estimate/${projectId}/kick-off/work-package/${WpId}/${year}/release-kick-off`);
  },
  saveKickOffWorkPackageTableBillingPlan: (id, wpId, year, body) => {
    return post(`project-estimate/${id}/kick-off/work-package/${wpId}/${year}/billing-plan`, body);
  },
  projectEstimateKickOffSummaryWbs: (id, wbsId, year) => {
    return get(`project-estimate/${id}/kick-off/summary/${year}/wbs/${wbsId}`);
  },
  projectEstimateKickOffSummaryWipWbs: (id, wbsId, year) => {
    return get(`project-estimate/${id}/kick-off/summary-wip/${year}/wbs/${wbsId}`);
  },
  kickOffSummaryVop: (projectEstimateId, year) => {
    return get(`project-estimate/${projectEstimateId}/kick-off/summary/${year}/vop`);
  },
  kickOffSummaryWipVop: (projectEstimateId, year) => {
    return get(`project-estimate/${projectEstimateId}/kick-off/summary-wip/${year}/vop`);
  },
  kickOffWpVop: (projectEstimateId, wpId, year) => {
    return get(`project-estimate/${projectEstimateId}/kick-off/work-package/${wpId}/${year}/vop`);
  },
};

export default KickOff;
